import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ServicesShowcase from "../../components/ServicesShowcase/ServicesShowcase";
import Footer from "../../components/Footer/Footer";
import Hero from "../../components/Hero/Hero";
import AboutIntro from "../../components/AboutIntro/AboutIntro";
import PartnersGrid from "../../components/PartnersGrid/PartnersGrid";
import WhyUs from "../../components/WhyUs/WhyUs";
import Statistics from "../../components/Statistics/Statistics";
import "./Home.css";

const Home = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        } else {
          entry.target.classList.remove("show");
        }
      });
    });

    const hiddenElements = document.querySelectorAll(".hidden");
    hiddenElements.forEach((element) => {
      observer.observe(element);
    });

    return () => {
      hiddenElements.forEach((element) => observer.unobserve(element));
    };
  }, []);

  return (
    <>
      <div className="header-margin">
        <Hero />

        <section className="section section--full">
          <AboutIntro />
        </section>

        <section className="section section--full">
          <WhyUs />
        </section>

        <section
          id="services"
          className="section section--full section--accent"
        >
          <div className="container">
            <h2>{t("home.servicesTitle")}</h2>
            <ServicesShowcase />
          </div>
        </section>

        <section className="section section--partners">
          <div className="container">
            <h2>{t("partners.title")}</h2>
            <PartnersGrid />
          </div>
        </section>

        <Statistics />
      </div>
      <Footer />
    </>
  );
};

export default Home;
